<script>
  import TableDropdown from "../components/Dropdowns/TableDropdown.svelte";
  import { t } from 'svelte-i18n';
  import Swal from 'sweetalert2';
  import { onMount, onDestroy } from "svelte";
  import * as XLSX from 'xlsx';
  import { jsPDF } from "jspdf";
  import "jspdf-autotable";    
  import Paginator from './Paginator.svelte';
  import Actions from './Actions.svelte';
  import CrudPane from "./CRUDPane.svelte";
  import CrudObjectPane from "./CrudObjetoPane.svelte";
  import { fetchSucursales } from '../controllers/sucursalController.js';
  import { fetchEmpresas } from '../controllers/empresaController.js';
  import { fetchVendedores } from '../controllers/vendedorController.js';
  import { fetchRoles } from '../controllers/roleController.js';
  import { POCKETBASE_URL } from "../config";
  import { authStore, initializeAuth } from '../lib/authStore.js';
  import { get } from 'svelte/store';
  import { Router, Route, navigate } from "svelte-routing";
  import pb from '../lib/pocketbase.js';
  import ChangePasswordModal from '../components/ChangePasswordModal.svelte';

  // Parámetros que se pueden reutilizar
  export let title = '';               // Título (e.g., Vendedores)
  export let entityName = '';           // Nombre de la entidad (e.g., vendedor)
  export let newEntity = {};            // Objeto del nuevo registro
  export let fetchEntities;             // Función para obtener los registros
  export let saveEntity;                // Función para guardar el registro
  export let removeEntity;              // Función para eliminar
  export let columns = [];              // Columnas de la tabla
  export let searchEntities;            // Función para buscar registros
  export let subscribeToChanges;        // Función para suscribirse a cambios
  export let unsubscribeFromChanges;    // Función para cancelar la suscripción
  export let editColumns;
  export let fetchAtributos = {};
  export let fetchImpuestos = {};
  export let importActivosFromCSV = null;
  export let enableGallery = false;
  export let galleryConfig = null;
  export let enableDetails = false;
  export let detailConfig = null;
  export let atributosConfig = null;
  export let onNewEntity = null;
  export let generateQuotationPDF = null; // Custom PDF generation function for quotations
  export let handleSendEmail = null; // Custom email sending function
  export let isSendingEmail = false; // Loading state for email sending

const params = window.location.pathname.split('/');
// Extract the entity type from the URL (e.g., "activo" from "/admin/activo/123")
// The URL structure is: /admin/entityName/id
const entityType = params[2]; // Get the third parameter (index 2) which should be the entity name
const objetoId = entityType; // Use entity type as objetoId for permissions

  const { authData } = get(authStore);
  let userRole = '';
  
    if (authData) {
      try {
        const parsedAuth = JSON.parse(authData);
        userRole = parsedAuth.role;
      } catch (parseError) {
        console.error('Error parsing auth data:', parseError);
        userRole = '';
      }
    } else {
      navigate('/auth/login');
    }
  
  let entities = [];
  let totalRecords = 0;
  let currentPage = 1;
  let perPage = 10;
  let searchQuery = '';
  let isPaneOpen = false;
  let isObjectPaneOpen = false;
  let currentEntityId = null;
  let isDirty = false;
  let itemsPerPageOptions = [10, 20, 50, 100, 500];

  let isMenuOpen = false; // Estado para controlar el menú hamburguesa
  
  let sortColumn = ''; // Nueva variable para almacenar la columna de ordenación
  let sortDirection = 'asc'; 

  let sucursalOptions = [];
  let empresaOptions = [];

  let canCreate = false; // Variable para manejar la visibilidad del botón "Crear"
  let canModify = false; // Variable para manejar la visibilidad del botón "Modificar"
  let canDelete = false; // Variable para manejar la visibilidad del botón "Eliminar"
  let showComponent = false; // Variable para manejar la visibilidad del componente
  let crudPermission = null;

  let showPasswordModal = false;
  let selectedUserId = '';

  function toggleMenu() {
    isMenuOpen = !isMenuOpen; // Cambia el estado del menú
  }

  // Function to evaluate column conditions
  function evalColumnCondition(condition, entity) {
    if (!condition) return true;
    
    try {
      // Replace field references with actual values
      let evalCondition = condition;
      if (entity) {
        Object.keys(entity).forEach(key => {
          const value = entity[key];
          const regex = new RegExp(`\\b${key}\\b`, 'g');
          evalCondition = evalCondition.replace(regex, `"${value}"`);
        });
      }
      
      // Evaluate the condition
      return eval(evalCondition);
    } catch (error) {
      console.warn('Error evaluating column condition:', condition, error);
      return true; // Show column by default if condition evaluation fails
    }
  }

  // Funciones reutilizables
  async function handleSearch(page = 1) {
    try {
      const data = searchQuery.trim() === ''
        ? await fetchEntities(page, perPage)
        : await searchEntities(searchQuery, page, perPage);
      
      if (data) {
        updateEntitiesData(data, page);
      }
    } catch (error) {
      // Handle auto-cancellation and other errors gracefully
      if (error.message && error.message.includes('autocancelled')) {
        console.warn('Search request was auto-cancelled, this is normal for rapid updates');
        return;
      }
      console.error('Error in handleSearch:', error);
      // Don't show error to user for real-time updates
    }
  }

  // Función genérica para encontrar el nombre de una entidad por su ID
  export async function getEntityName(id, fetchFunction, entityName, keyField = 'id', valueField = 'descrip') {
      try {
          // Almacenamos las opciones cargadas en una variable estática por entidad
          if (!getEntityName.cache) {
              getEntityName.cache = {};
          }

          if (!getEntityName.cache[entityName]) {
              getEntityName.cache[entityName] = [];
          }

          // Si las opciones ya fueron cargadas, las usamos
          let entityOptions = getEntityName.cache[entityName];

          if (entityOptions.length === 0) {
              try {
                  const fetchedData = await fetchFunction();

                  if (fetchedData && Array.isArray(fetchedData[entityName])) {
                      // Mapea los resultados a un arreglo de { key, value }
                      entityOptions = fetchedData[entityName].map(e => ({
                          key: e[keyField],
                          value: e[valueField],
                      }));

                      // Almacena las opciones en caché
                      getEntityName.cache[entityName] = entityOptions;
                  } else {
                      console.error(`La respuesta de ${entityName} no es válida:`, fetchedData);
                      return `${entityName} no encontrada`;
                  }
              } catch (error) {
                  console.error(`Error al cargar ${entityName}:`, error);
                  return `Error al cargar ${entityName}`;
              }
          }

          // Buscar la entidad correspondiente por su ID
          const entity = entityOptions.find(option => option.key === id);

          if (entity) {
              return entity.value;
          } else {
              console.warn(`${entityName} con ID ${id} no encontrada`);
              return `${entityName} no encontrada`;
          }
      } catch (error) {
          console.error(`Error in getEntityName for ${entityName}:`, error);
          return `Error al cargar ${entityName}`;
      }
  }
  async function updateEntitiesData(data, page) {
    try {
      if (data && data[entityName]) {
        let updatedEntities = [];

        for (let entity of data[entityName]) {
          // Si la entidad tiene una sucursal, reemplaza el ID por el nombre de la sucursal
          if (entity.sucursal) {
            try {
              const sucursalNombre = await getEntityName(entity.sucursal, fetchSucursales, 'sucursal', 'id', 'descrip');
              entity.sucursal_descrip = sucursalNombre;
            } catch (error) {
              console.warn('Error getting sucursal name:', error);
              entity.sucursal_descrip = 'Error';
            }
          }
          // Si la entidad tiene una empresa, reemplaza el ID por el nombre de la empresa
          if (entity.empresa) {
            try {
              const empresaNombre = await getEntityName(entity.empresa, fetchEmpresas, 'empresa', 'id', 'nombre_comercial');
              entity.empresa_descrip = empresaNombre;
            } catch (error) {
              console.warn('Error getting empresa name:', error);
              entity.empresa_descrip = 'Error';
            }
          }
          // Si la entidad tiene un role, reemplaza el ID por la descripción del role
          if (entity.role) {
            try {
              const roleDescrip = await getEntityName(entity.role, fetchRoles, 'role', 'id', 'descrip');
              entity.role_descrip = roleDescrip;
            } catch (error) {
              console.warn('Error getting role description:', error);
              entity.role_descrip = 'Error';
            }
          }
          // Si la entidad tiene un vendedor, reemplaza el ID por el nombre del vendedor
          if (entity.vendedor) {
            try {
              const vendedorNombre = await getEntityName(entity.vendedor, fetchVendedores, 'vendedor', 'id', 'nombre');
              entity.vendedor_nombre = vendedorNombre;
            } catch (error) {
              console.warn('Error getting vendedor name:', error);
              entity.vendedor_nombre = 'Error';
            }
          }
          updatedEntities.push(entity);
        }

        entities = updatedEntities;
        totalRecords = data.totalRecords || 0;
        currentPage = page;
      } else {
        resetEntityData();
      }
    } catch (error) {
      // Fallback to reset if there's an error
      resetEntityData();
    }
  }

  async function fetchEntitiesData(page = 1) {
    try {
      const data = await fetchEntities(page, perPage);
      if (data) {
        updateEntitiesData(data, page);
      }
    } catch (error) {
      console.error('Error fetching entities data:', error);
      // Don't show error to user for real-time updates
    }
  }

  async function saveEntry(closePane = true) {
    try {
      const result = await saveEntity(newEntity, currentEntityId);
      
      // If this was a new entity creation, update currentEntityId with the new ID
      if (!currentEntityId && result && result.id) {
        currentEntityId = result.id;
      }
      
      await handleSearch(currentPage);
      
      // Only close pane if explicitly requested (default behavior)
      if (closePane) {
        togglePane();
      }
      
      isDirty = false;
      
      return result; // Return the result for use by EmbeddedDetailTable
    } catch (error) {
      console.error('Error saving entry:', error);
      // Error handling is done in the saveEntity function
      throw error; // Re-throw so EmbeddedDetailTable can handle it
    }
  }

  async function editEntity(entity) {
    try {
      // Create a copy of the entity for editing
      newEntity = { ...entity };
      
      // Ensure atributos field exists for entities that support it
      if (entityName === 'producto' || entityName === 'activo') {
        if (!newEntity.atributos) {
          newEntity.atributos = [];
        }
      }
      
      // Fix select field values for relation fields that are expanded
      editColumns.forEach(col => {
        if (col.type === 'select' && col.key === 'tipo' && entity.tipoId) {
          // For tipo field, use the preserved ID
          newEntity[col.key] = entity.tipoId;
        }
        if (col.type === 'select' && col.key === 'role' && entity.roleId) {
          // For role field, use the preserved ID
          newEntity[col.key] = entity.roleId;
        }
      });
      
      currentEntityId = entity.id;
      isPaneOpen = true;
      isDirty = true;

      // Cargar las opciones de las entidades relacionadas
      if (typeof fetchAtributos === 'function') {
        try {
          newEntity['atributos'] = await loadAtributos(currentEntityId);
        } catch (error) {
          console.warn('Error loading atributos:', error);
          newEntity['atributos'] = [];
        }
      }

      if (typeof fetchImpuestos === 'function') {
        try {
          newEntity['impuestos'] = await loadImpuestos(currentEntityId);
        } catch (error) {
          console.warn('Error loading impuestos:', error);
          newEntity['impuestos'] = [];
        }
      }

      // Handle multiselect fields (like categories)
      if (entityName === 'producto') {
        try {
          const categorias = await fetchCategoriasProducto(currentEntityId);
          // Transform categories to match the multiselect format
          newEntity['categorias'] = categorias.map(cat => ({
            key: cat.categoria.id,
            value: cat.categoria.descrip
          }));
        } catch (error) {
          console.warn('Error loading categorias:', error);
          newEntity['categorias'] = [];
        }

        // Handle parent multiselect field
        try {
          if (entity.parent && Array.isArray(entity.parent) && entity.parent.length > 0) {
            // Transform parent IDs to multiselect format
            newEntity['parent'] = entity.parent.map(parentProduct => {
              // If parent is already expanded object
              if (typeof parentProduct === 'object' && parentProduct.id) {
                return {
                  key: parentProduct.id,
                  value: parentProduct.nombre
                };
              }
              // If parent is just an ID string
              return {
                key: parentProduct,
                value: parentProduct // Will be replaced by the actual name when options are loaded
              };
            });
          } else {
            newEntity['parent'] = [];
          }
        } catch (error) {
          console.warn('Error loading parent products:', error);
          newEntity['parent'] = [];
        }
      }
    } catch (error) {
      console.error('Error editing entity:', error);
    }
  }

  async function deleteEntity(id) {
    const result = await Swal.fire({
      title: $t('common.deleteConfirmTitle', { values: { entity: entityName } }),
      text: $t('common.deleteConfirmText'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: $t('common.deleteConfirmButton'),
    });

    if (result.isConfirmed) {
      try {
        await removeEntity(id);
        await handleSearch(currentPage);
      } catch (error) {
        console.error('Error deleting entity:', error);
        // Error handling is done in the removeEntity function
      }
    }
  }

  onMount(async () => {
    try {
      await handleSearch();
      if (typeof subscribeToChanges === 'function') {
        subscribeToChanges(searchQuery, (page = currentPage) => handleSearch(page));
      }
      window.addEventListener('beforeunload', handleBeforeUnload);

      // Only check permissions if we have a valid user role
      let permission = null;
      if (userRole && userRole.trim() !== '') {
        // PROPER: Find the objeto record that matches the entity name
        permission = await checkRoleObjetoCRUD(objetoId, userRole);
        
        // If no permissions found, find the objeto record by description
        if (!permission) {          
          try {
            // Get all objeto records to find one that matches the entity name
            const allObjetos = await pb.collection('objeto').getFullList({
              $autoCancel: false
            });
            
            // Find objeto record that matches the entity name (case-insensitive)
            const matchingObjeto = allObjetos.find(obj => {
              if (!obj.descrip) return false;
              
              // Handle both string and object descrip
              let descripText = '';
              if (typeof obj.descrip === 'string') {
                descripText = obj.descrip;
              } else if (typeof obj.descrip === 'object') {
                // If it's an object, try to get a string value
                descripText = obj.descrip.esp || obj.descrip.eng || JSON.stringify(obj.descrip);
              } else {
                descripText = String(obj.descrip);
              }
              
              return descripText.toLowerCase().includes(objetoId.toLowerCase()) ||
                     objetoId.toLowerCase().includes(descripText.toLowerCase());
            });
            
            if (matchingObjeto) {
              // Now check permissions using the actual objeto ID
              permission = await checkRoleObjetoCRUD(matchingObjeto.id, userRole);
            }
          } catch (error) {
            console.warn('Could not search objeto records:', error);
          }
        }
      }
      
      crudPermission = permission;
      
      // STRICT PERMISSION SYSTEM: Respect what's explicitly set, allow basic access when not configured
      if (!crudPermission || crudPermission === '') {
        canCreate = true;  // Allow basic operations when not configured
        canModify = true;  // Allow basic operations when not configured
        canDelete = true;  // Allow basic operations when not configured
        showComponent = true; // Show the component
      } else {
        // When permissions ARE found, be strict about what's allowed
        showComponent = crudPermission.includes('C');
        canCreate = crudPermission.includes('A');
        canModify = crudPermission.includes('M');
        canDelete = crudPermission.includes('E');
      }
      
      // Special handling for Roles view - always allow object management
      if (entityName === 'role') {
        canModify = true; // Always allow modification for roles to access Objetos menu
      }
      
    } catch (error) {
      console.error('Error in onMount:', error);
      // Fallback: show component with basic permissions if there's an error
      showComponent = true;
      canCreate = false;
      canModify = false;
      canDelete = false;
    }
    
    return () => {
      if (typeof unsubscribeFromChanges === 'function') {
        unsubscribeFromChanges();
      }
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  });

  function handleBeforeUnload(event) {
    try {
      if (isDirty) {
        const confirmationMessage = $t('common.unsavedChangesPrompt');
        event.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    } catch (error) {
      console.error('Error in beforeunload handler:', error);
    }
  }

  function togglePane() {
    try {
      isPaneOpen = !isPaneOpen;
      if (!isPaneOpen) {
        resetForm();
      } else if (onNewEntity && typeof onNewEntity === 'function') {
        // Call onNewEntity when opening pane for new entity
        onNewEntity();
      }
    } catch (error) {
      console.error('Error toggling pane:', error);
    }
  }

  function resetForm() {
    try {
      // Reset based on entity type
      if (entityName === 'role') {
        newEntity = { descrip: '', sta: true };
      } else if (entityName === 'users') {
        newEntity = { name: '', email: '', role: '', password: '', passwordConfirm: '', verified: false, avatar: '', emailVisibility: true };
      } else {
        // Default fallback for other entities
        newEntity = { sta: true };
      }
      currentEntityId = null;
      isDirty = false;
    } catch (error) {
      console.error('Error resetting form:', error);
    }
  }

  async function handlePageChange(direction) {
    try {
      const newPage = currentPage + direction;
      const totalPages = Math.ceil(totalRecords / perPage);
      if (newPage > 0 && newPage <= totalPages) {
        await handleSearch(newPage);
      }
    } catch (error) {
      console.error('Error changing page:', error);
    }
  }

  async function handleItemsPerPageChange(newPerPage) {
      try {
          perPage = parseInt(newPerPage); // Convert string to number
          currentPage = 1; // Reset to the first page when changing items per page
          await handleSearch(currentPage); // Use handleSearch to respect current search query
      } catch (error) {
          console.error('Error changing items per page:', error);
      }
  }

  function exportToExcel() {
    try {
      // Create a new workbook
      const wb = XLSX.utils.book_new();

      // Prepare data for the worksheet
      const wsData = [
          columns.map(column => column.label), // Header
          ...entities.map(entity => 
              columns.map(col => {
                  // Obtiene el valor de la entidad basándose en la clave de columna
                  if (col.field === 'sta' || col.field === 'default') {
                      return entity[col.field] ? $t('common.active') : $t('common.inactive');
                  } else if (col.type === 'gallery_image') {
                      return entity[col.field] && entity[col.field].url ? 'Con imagen' : 'Sin imagen';
                  }
                  return entity[col.field]; // Retorna el valor de la entidad para otras columnas
              })
          )
      ];

      // Create a worksheet
      const ws = XLSX.utils.aoa_to_sheet(wsData);

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, title);

      // Generate the Excel file and prompt the user to download
      XLSX.writeFile(wb, title + ".xlsx");
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      // Could show a user-friendly error message here
    }
  }

  function exportToPDF() {
    try {
      const doc = new jsPDF();

      // Agregar el encabezado
      doc.setFontSize(18); // Tamaño de la fuente del título
      doc.text(title, 105, 10, { align: 'center' }); // Título centrado en la parte superior
      doc.setFontSize(12); // Tamaño de fuente para el resto del contenido

      // Define column headers
      const headers = [columns.map(column => column.label)];

      // Define rows (data)
      const rows = entities.map(entity => 
          columns.map(col => {
              // Maneja los valores booleanos para 'sta' y 'default'
              if (col.field === 'sta' || col.field === 'default') {
                  return entity[col.field] ? $t('common.active') : $t('common.inactive');
              } else if (col.type === 'gallery_image') {
                  return entity[col.field] && entity[col.field].url ? 'Con imagen' : 'Sin imagen';
              }
              return entity[col.field]; // Retorna el valor de la entidad para otras columnas
          })
      );

      // Use autoTable to create the table
      doc.autoTable({
          head: headers,
          body: rows,
          startY: 15, // Optional: where the table should start vertically
      });

      // Save the PDF
      doc.save(title + ".pdf");
    } catch (error) {
      console.error('Error exporting to PDF:', error);
      // Could show a user-friendly error message here
    }
  }

  // Import from CSV function
  async function importFromCSV() {
    try {
      // Check if import function is available
      if (!importActivosFromCSV) {
        Swal.fire('Error', 'Función de importación no disponible para esta entidad', 'error');
        return;
      }

      // Create file input element
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = '.csv';
      fileInput.style.display = 'none';
      
      fileInput.onchange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
          const text = await file.text();
          
          // Show loading
          Swal.fire({
            title: 'Importando...',
            text: 'Procesando archivo CSV',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          // Import the data
          const result = await importActivosFromCSV(text);
          
          // Show results
          if (result.success) {
            let message = `Importación completada:\n`;
            message += `✓ ${result.successCount} registros importados exitosamente\n`;
            
            if (result.errorCount > 0) {
              message += `⚠ ${result.errorCount} errores encontrados\n\n`;
              message += `Primeros errores:\n${result.errors.join('\n')}`;
            }

            await Swal.fire({
              title: $t('import.successTitle'),
              text: message,
              icon: 'success',
              confirmButtonText: 'OK'
            });

            // Refresh the data
            await handleSearch(currentPage);
          }
        } catch (error) {
          console.error('Error importing CSV:', error);
          await Swal.fire({
            title: $t('import.errorTitle'),
            text: error.message || 'Error desconocido al importar el archivo',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        } finally {
          // Clean up
          document.body.removeChild(fileInput);
        }
      };

      // Add to DOM and trigger click
      document.body.appendChild(fileInput);
      fileInput.click();
    } catch (error) {
      console.error('Error setting up CSV import:', error);
      Swal.fire('Error', $t('import.setupError'), 'error');
    }
  }


  function resetEntityData() {
    try {
      entities = [];
      totalRecords = 0;
      currentPage = 1;
    } catch (error) {
      console.error('Error resetting entity data:', error);
    }
  }

  function handleInputChange() {
    try {
      isDirty = true;
    } catch (error) {
      console.error('Error handling input change:', error);
    }
  }

  function sortTable(column) {
    try {
      if (sortColumn === column) {
          sortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
          sortColumn = column;
          sortDirection = 'asc';
      }

      entities = [...entities.sort((a, b) => {
          const valueA = a[column];
          const valueB = b[column];

          if (valueA < valueB) {
              return sortDirection === 'asc' ? -1 : 1;
          }
          if (valueA > valueB) {
              return sortDirection === 'asc' ? 1 : -1;
          }
          return 0;
      })];
    } catch (error) {
      console.error('Error sorting table:', error);
    }
  }

  function formatDate(dateStr) {
    try {
      const date = new Date(dateStr);
      if (isNaN(date)) return ''; // Manejo de fechas inválidas

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son 0-indexados
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  }

  // Función para cargar atributos de cualquier entidad
  async function loadAtributos(currentEntityId) {
    try {
        const fetchedData = await fetchAtributos(currentEntityId); // Llama a la función de atributos

        if (Array.isArray(fetchedData['atributos'])) {
          return fetchedData['atributos'];
        } else if (Array.isArray(fetchedData)) {
          return fetchedData;
        } else {
          console.warn('No se encontraron atributos, retornando array vacío:', fetchedData);
          return [];
        }
    } catch (error) {
        console.error('Error al cargar los atributos:', error);
    }
  }

    // Función para cargar impuestos de cualquier entidad
    async function loadImpuestos(currentEntityId) {
    try {
        const fetchedData = await fetchImpuestos(currentEntityId); // Llama a la función de atributos

        if (Array.isArray(fetchedData['impuestos'])) {
          return fetchedData['impuestos'];
        } else {
          console.error('Se esperaba un array de impuestos, pero se obtuvo:', fetchedData);
        }
    } catch (error) {
        console.error('Error al cargar los impuestos:', error);
    }
  }

  // Cargar las opciones de las entidades relacionadas
  async function editObjetos(entity) {
    try {
      newEntity = { ...entity };
      currentEntityId = entity.id;
      isObjectPaneOpen = true;
      isDirty = true;
    } catch (error) {
      console.error('Error editing objetos:', error);
    }
  }

  async function toggleObjectPane() {
    try {
      isObjectPaneOpen = !isObjectPaneOpen;
      // Don't reset form when closing object pane - this is for object management, not entity editing
      if (!isObjectPaneOpen) {
        // Just close the pane, don't reset the form
      }
    } catch (error) {
      console.error('Error toggling object pane:', error);
    }
  }

   // Nueva función para verificar el campo crud de role_objeto
  async function checkRoleObjetoCRUD(objetoId, roleId) {
      try {
          // Aquí debes realizar la llamada a la API o a la base de datos para obtener el registro correspondiente
          const filter = `objeto = '${objetoId}' && role = '${roleId}'`;
          
          const data = await pb.collection('role_objeto').getFullList({
              filter: filter,
              $autoCancel: false // Disable auto-cancellation for permission checks
          });

          // Comprobar si se encontró un registro
          if (data && data.length > 0) {
              // Retornar el campo crud del primer registro encontrado
              return data[0].CRUD;
          } else {
              return null; // o un valor por defecto que prefieras
          }
      } catch (error) {
          // Handle auto-cancellation errors gracefully
          if (error.message && error.message.includes('autocancelled')) {
              console.warn('Permission check was auto-cancelled, this is normal for rapid updates');
              return null;
          }
          console.error('Error al comprobar crud de role_objeto:', error);
          return null; // o un valor por defecto
      }
  }
  
  function handlePasswordChange(userId) {
    try {
      selectedUserId = userId;
      showPasswordModal = true;
    } catch (error) {
      console.error('Error handling password change:', error);
    }
  }

  function handleClosePasswordModal() {
    try {
      showPasswordModal = false;
      selectedUserId = '';
    } catch (error) {
      console.error('Error closing password modal:', error);
    }
  }
</script>

{#if showComponent}

    <CrudPane
      newEntity={newEntity}
      currentEntityId={currentEntityId}
      isPaneOpen={isPaneOpen}
      togglePane={togglePane}
      saveEntityEntry={saveEntry}
      entityName={entityName}
      editColumns={editColumns}
      on:inputChange={handleInputChange}
      canModify={canModify}
      canCreate={canCreate}
      title={title}
      enableGallery={enableGallery}
      galleryConfig={galleryConfig}
      enableDetails={enableDetails}
      detailConfig={detailConfig}
      atributosConfig={atributosConfig}
      generateQuotationPDF={generateQuotationPDF}
      isGeneratingPDF={false}
      handleSendEmail={handleSendEmail}
      isSendingEmail={isSendingEmail}
    />

    <CrudObjectPane 
      newEntity={newEntity} 
      isObjectPaneOpen={isObjectPaneOpen} 
      toggleObjectPane={toggleObjectPane} 
    />

    <div class="relative md:pt-6 pb-16 flex justify-between items-center">
      <h2 class="text-white text-lg font-bold">{$t('crud.management', { values: { title } })}</h2>
      <div class="flex items-center ml-auto">
          <Actions 
              {togglePane}
              {exportToExcel}
              {exportToPDF}
              {importFromCSV}
              {isMenuOpen}
              {toggleMenu}
              {canCreate}
          />
          &nbsp;
          <input
              type="text"
              bind:value={searchQuery}
              on:input={() => handleSearch(1)}
              placeholder="{$t('common.searchPlaceholder')}"
              class="px-4 py-2 border rounded border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ml-4"
          />
      </div>
    </div>
    
    <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
      <div class="block w-full overflow-x-auto">
        <table class="items-center w-full bg-transparent border-collapse">
          <thead>
            <tr>
                
              {#each columns as col}
                {#if !col.condition || evalColumnCondition(col.condition, {})}
                  <th 
                    class="px-6 py-3 text-xs uppercase border border-l-0 border-r-0 font-semibold {col.type === 'gallery_image' ? '' : 'cursor-pointer'}"
                    on:click={col.type === 'gallery_image' ? undefined : () => sortTable(col.field)}
                  >
                    {col.label}
                    {#if sortColumn === col.field}
                      {#if sortDirection === 'asc'}
                        ▲
                      {:else}
                        ▼
                      {/if}
                    {/if}
                  </th>
                {/if}
              {/each}
              <th class="px-6 py-3 text-xs uppercase border border-l-0 border-r-0 font-semibold"></th>
            </tr>
          </thead>
          <tbody>
            {#each entities as entity}
              <tr>
                {#each columns as col}
                  {#if !col.condition || evalColumnCondition(col.condition, entity)}
                    <td class="px-6 py-3 text-xs">
                      {#if col.type === 'bool'}
                          {entity[col.field] ? $t('common.active') : $t('common.inactive')}
                      {:else if col.type === 'date'}
                          {entity[col.field] ? formatDate(entity[col.field]) : ''}
                      {:else if col.type === 'image'}
                        <img src={POCKETBASE_URL+'/api/files/'+entity['collectionId']+'/'+entity['id']+'/'+entity[col.field]} alt={$t('gallery.preview')} class="mt-2 w-24 h-24 object-cover" style="width: 100px;" />
                      {:else if col.type === 'gallery_image'}
                        {#if entity[col.field] && entity[col.field].url}
                          <img src={POCKETBASE_URL+'/api/files/'+entity[col.field].collectionId+'/'+entity[col.field].id+'/'+entity[col.field].url} alt={$t('gallery.galleryPreview')} class="mt-2 w-16 h-16 object-cover rounded" style="width: 64px; height: 64px;" />
                        {:else}
                          <span class="text-gray-400 text-xs">Sin imagen</span>
                        {/if}
                      {:else if col.type === 'relation' && col.relationField && entity[col.field]}
                          {#if typeof entity[col.field] === 'object' && entity[col.field][col.relationField]}
                              {entity[col.field][col.relationField]}
                          {:else}
                              {entity[col.field]}
                          {/if}
                      {:else if col.type === 'categories'}
                          {#if entity[col.field] && Array.isArray(entity[col.field]) && entity[col.field].length > 0}
                              <div class="flex flex-wrap gap-1">
                                  {#each entity[col.field] as categoria}
                                      <span class="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800">
                                          {categoria.categoria?.descrip || categoria.nombre || categoria.descrip}
                                      </span>
                                  {/each}
                              </div>
                          {:else}
                              <span class="text-gray-400 text-xs">
                                  {col.field === 'parent' ? $t('common.noParent') : $t('common.noCategories')}
                              </span>
                          {/if}
                      {:else}
                          {entity[col.field]}
                      {/if}
                    </td>
                  {/if}
                {/each}
              
                <td class="px-6 py-3 text-xs text-right">
                  <TableDropdown 
                    onEdit={() => editEntity(entity)} 
                    onDelete={() => deleteEntity(entity.id)} 
                    onObjetos={() => editObjetos(entity)}
                    onPasswordChange={entityName === 'users' ? () => handlePasswordChange(entity.id) : undefined}
                    closeDropdown={() => {}} 
                    entityName={entityName}
                    canDelete={canDelete}
                    canModify={canModify}
                  />
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
    

      <Paginator 
          {currentPage} 
          {totalRecords} 
          {perPage} 
          {itemsPerPageOptions} 
          onPageChange={handlePageChange} 
          onItemsPerPageChange={handleItemsPerPageChange}
      />

  <ChangePasswordModal 
    show={showPasswordModal}
    userId={selectedUserId}
    on:close={handleClosePasswordModal}
  />
{:else}
    <div class="flex items-center justify-center h-96">
        <h2 class="text-2xl text-white z-10">No tienes permiso para acceder a esta sección.</h2>
    </div>
{/if}
